import React, { useState } from 'react'
import { AproveController } from './styled'
import { IconButton, InputGroup, InputLeftAddon } from '@chakra-ui/core'
import { setRemoteCall } from '../../remote'
import { Box, Input } from '@material-ui/core'

export default (props) => {
  const [days, setDays] = useState(0)
  const approveRelation = (e) => {
    setRemoteCall(
      'aproveRelation',
      {
        _id: props.relationId,
        days: days,
      },
      null
    )
  }

  const cancelRelation = (e) => {
    setRemoteCall(
      'cancelRelation',
      {
        _id: props.relationId,
      },
      null
    )
  }

  const copyRelation = (e) => {
    setRemoteCall(
      'copyRelation',
      {
        _id: props.relationId,
        days: days,
      },
      null
    )
  }

  return (
    <AproveController>
      <InputGroup size={'sm'} mt={'0.5em'}>
        <InputLeftAddon fontSize={'.8em'} p={'4px'} h={'1rem'}>
          Dias
        </InputLeftAddon>
        <Input
          value={days}
          onChange={(e) => setDays(e.target.value)}
          type="number"
          placeholder="Dias"
          style={{
            width: '50px',
            height: '1rem',
            fontSize: '10px',
            marginLeft: '5px',
          }}
        />
      </InputGroup>
      <IconButton
        height={'1rem'}
        width={'1rem'}
        fontSize="10px"
        aria-label="reject"
        icon="close"
        size="sm"
        variant="outline"
        onClick={() => cancelRelation()}
      />
      <IconButton
        aria-label="approve"
        icon="check"
        variant="outline"
        size="sm"
        height={'1rem'}
        width={'1rem'}
        fontSize="10px"
        onClick={() => approveRelation()}
      />
      <IconButton
        aria-label="copy"
        icon="copy"
        variant="outline"
        size="sm"
        height={'1rem'}
        width={'1rem'}
        fontSize="12px"
        onClick={() => copyRelation()}
      />
    </AproveController>
  )
}
